import { useEffect, useRef, useState } from 'react';
var MIN_REVEAL_MS = 400;
var MAX_REVEAL_MS = 2500;
var MS_PER_CHAR = 25;
var TICK_MS = 16;
export var useStreamReveal = function useStreamReveal(_ref) {
  var _content$length;

  var content = _ref.content,
      enabled = _ref.enabled,
      onComplete = _ref.onComplete;

  var _useState = useState(0),
      revealedLength = _useState[0],
      setRevealedLength = _useState[1];

  var _useState2 = useState(false),
      hasCompleted = _useState2[0],
      setHasCompleted = _useState2[1];

  var onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;
  useEffect(function () {
    if (!enabled || !content) {
      setRevealedLength(0);
      setHasCompleted(false);
      return;
    }

    setRevealedLength(0);
    setHasCompleted(false);
    var totalLen = content.length;

    if (totalLen === 0) {
      var _onCompleteRef$curren;

      setHasCompleted(true);
      (_onCompleteRef$curren = onCompleteRef.current) === null || _onCompleteRef$curren === void 0 ? void 0 : _onCompleteRef$curren.call(onCompleteRef);
      return;
    }

    var durationMs = Math.min(MAX_REVEAL_MS, Math.max(MIN_REVEAL_MS, totalLen * MS_PER_CHAR));
    var step = 1;
    var intervalId = setInterval(function () {
      setRevealedLength(function (prev) {
        var next = Math.min(prev + step, totalLen);

        if (next >= totalLen) {
          var _onCompleteRef$curren2;

          clearInterval(intervalId);
          setHasCompleted(true);
          (_onCompleteRef$curren2 = onCompleteRef.current) === null || _onCompleteRef$curren2 === void 0 ? void 0 : _onCompleteRef$curren2.call(onCompleteRef);
        }

        return next;
      });
    }, TICK_MS);
    return function () {
      return clearInterval(intervalId);
    };
  }, [content, enabled]);
  var revealedContent = enabled ? content.slice(0, revealedLength) : content;
  var isComplete = !enabled || hasCompleted || revealedLength >= ((_content$length = content === null || content === void 0 ? void 0 : content.length) !== null && _content$length !== void 0 ? _content$length : 0);
  return {
    revealedContent: revealedContent,
    isComplete: isComplete
  };
};